// named export (recommended)
export const ECOMMERCE = {
    // section: ["overviewSection", "roiInvestorBenefits", "operationalBenefits", "launchOperatingModel", "communicationChannel"],
    href: "/investments/ecommerce",
    overviewSection: {
        sectionId: "ecomoverview",
        title: "Overview",
        subtitle:
            "The RSL E-Commerce Investment Module delivers a ready-made e-commerce business, built and handed over fully operational.",
        cards: [
            {
                title: "Business licensing",
                body: "Under UAE Free Zone/Mainland structure",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Custom-built online store",
                body: "With branding and payment gateways",
                arrow: "/img/app/Right-bottom-arrow.svg",
            },
            {
                title: "Product sourcing",
                body: "High-demand items from global suppliers",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Full product uploads",
                body: "with descriptions, pricing, and images.",
                arrow: "/img/app/Right-bottom-arrow.svg",
            },
            {
                title: "Marketing & ads",
                body: "under UAE Free Zone/Mainland structure",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Ongoing support",
                body: "under UAE Free Zone/Mainland structure"
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "benefits",
        title: "Operational Benefits for Investors",
        subtitle:
            "Choose which suits you better",
        image: {
            src: "/img/investments/benefits.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
        width: "90%"
    },
    operationalBenefits: {
        sectionId: "ROIBenefits",
        title: "ROI & Investor Benefits",
        subtitle:
            "Choose which suits you better",
        ringImage: {
            src: "/img/investments/investorBenefits.svg",
            alt: "Investor Benefits"
        },
        complianceImage: {
            src: "/img/investments/years.svg",
            alt: "Years"
        },
        button: { text: "Invest Now", link: "#" },
    },
    launchOperatingModel: {
        sectionId: "launchSystem",
        title: "Operating Model",
        subtitle:
            "Step-by-step Launch System",
        image: {
            src: "/img/investments/step-by-step.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
    },
    // launchOperatingModel: {
    //     title: "Operating Model",
    //     subtitle:
    //         "Step-by-step Launch System",
    //     steps: [
    //         {
    //             title: "Setup & Compliance",
    //             items: [
    //                 "Business licensing under UAE laws.",
    //                 "VAT registration and trade license support.",
    //                 "Payment gateway integration with secure settlement.",
    //             ],
    //         },
    //         {
    //             title: "Store Development",
    //             items: [
    //                 "Fully branded E-Commerce store.",
    //                 "Multi-currency & multilingual.",
    //                 "Payment gateway integration with secure settlement.",
    //             ],
    //         },
    //         {
    //             title: "Product Sourcing & Logistics",
    //             items: [
    //                 "Supplier from China, Turkey, UAE wholesaler",
    //                 "Dropshipping model (no inventory needed).",
    //                 "Courier & logistics partnerships for fast delivery.",
    //             ],
    //         },
    //         {
    //             title: "Marketing & user Acquisition",
    //             items: [
    //                 "Setup of Instagram, TikTok, Meta Ads.",
    //                 "SEO and influencer outreach strategy.",
    //                 "Conversion optimization and customer funnel setup.",
    //             ],
    //         },
    //         {
    //             title: "Handover & Investor Training",
    //             items: [
    //                 "Transfer of all business assets",
    //                 "Investor training sessions.",
    //                 "Optional ongoing RSL support package.",
    //             ],
    //         },
    //     ],
    //     borderImages: {
    //         first: "/img/investments/frame-first.svg",   // ← your “start” frame with no left arrow
    //         middle: "/img/investments/frame-middle.svg", // ← frame + arrow to the right
    //         last: "/img/investments/frame-last.svg",     // ← end frame with no right arrow
    //     },
    //     button: { text: "Invest Now", link: "#" }
    // },
    communicationChannel: {
        sectionId: "communicationChannel",
        title: "Communication Channel",
        subtitle:
            "Choose which suits you better",
        bottomHeader: "RSL ensures smooth communication and transparency for all investors and drivers:",
        cardData: [
            {
                heading: "Call Center (UAE):",
                iconSrc: "/img/investments/phone.svg",
                iconAlt: "Phone",
                url: [
                    {
                        href: "tel:+97143977746",
                        label: "+971 4 397 7746"
                    }
                ]
            },
            {
                heading: "Email (Investors):",
                iconSrc: "/img/investments/email.svg",
                iconAlt: "Email",
                url: [
                    {
                        href: "mailto:investors@royalsmartlifestyle.com",
                        label: "investors@royalsmartlifestyle.com"
                    }
                ]
            },
            {
                heading: "Websites",
                iconSrc: "/img/investments/globe.svg",
                iconAlt: "Globe",
                url: [{
                    href: "https://www.royalsmartlimousine.com",
                    label: "https://www.royalsmartlimousine.com"
                }]
            }
        ],
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
};

export const ECOMMERCE_PAGE = {
    productList: {
        sectionId: "overview",
        title: "Steps For List Products With RSL",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/ecommerce/product-list.svg",
            alt: "Product List"
        },
        button: { text: "Invest Now", link: "#" },
        bgcolor: "#fff",
    },
    approvesBusiness: {
        sectionId: "overview",
        title: "ROI & Investor Benefits",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/ecommerce/investor-benefits.svg",
            alt: "Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
        bgcolor: "#f9f9f9",
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}